/* coldest-shipping-progress.js
 * Adds a dynamic "X away from free shipping" progress bar that:
 *   1. Replaces the static announcement-bar message with live status when cart > $0
 *   2. Injects into the cart drawer (Coldest theme uses .cart-drawer or .cart-page)
 *
 * Threshold: $125 (USA orders) per Coldest's free shipping policy.
 *
 * The script polls /cart.js whenever:
 *   - DOMContentLoaded
 *   - any "cart:added" / "cart:updated" event the theme dispatches
 *   - any AJAX POST to /cart/add (intercepted via fetch wrapper)
 */
(function() {
  'use strict';

  var THRESHOLD_CENTS = 12500; // $125
  var POLL_DEBOUNCE_MS = 300;

  function fmtPrice(cents) {
    return '$' + (cents / 100).toFixed(cents % 100 === 0 ? 0 : 2);
  }

  function makeBarHTML(remaining, subtotal) {
    var pct = Math.min(100, Math.round(subtotal * 100 / THRESHOLD_CENTS));
    var msg = remaining <= 0
      ? "🎉 You unlocked FREE shipping!"
      : "You're " + fmtPrice(remaining) + " away from FREE shipping";
    return [
      '<div class="cdst-shipbar" data-pct="' + pct + '">',
        '<div class="cdst-shipbar-msg">' + msg + '</div>',
        '<div class="cdst-shipbar-track">',
          '<div class="cdst-shipbar-fill" style="width:' + pct + '%"></div>',
        '</div>',
      '</div>'
    ].join('');
  }

  function injectStyles() {
    if (document.getElementById('cdst-shipbar-css')) return;
    var s = document.createElement('style');
    s.id = 'cdst-shipbar-css';
    s.textContent = [
      '.cdst-shipbar { padding: 10px 16px; background: #f7f5f0; border-bottom: 1px solid #ece7da; font-size: 13px; color: #2a2a2a; }',
      '.cdst-shipbar-msg { font-weight: 600; margin-bottom: 6px; text-align: center; }',
      '.cdst-shipbar-track { height: 6px; background: #e6e1d4; border-radius: 3px; overflow: hidden; }',
      '.cdst-shipbar-fill { height: 100%; background: linear-gradient(90deg, #d4a017 0%, #2e7d32 100%); border-radius: 3px; transition: width 0.3s ease-out; }',
      '.cdst-shipbar[data-pct="100"] .cdst-shipbar-fill { background: #2e7d32; }',
      '.cdst-shipbar[data-pct="100"] .cdst-shipbar-msg { color: #1b5e20; }',
      /* Inside cart drawer */
      '.cart-drawer .cdst-shipbar, .ajax-cart .cdst-shipbar, [data-cart-drawer] .cdst-shipbar { margin: 0 0 12px; border-radius: 6px; border: 1px solid #ece7da; }'
    ].join('\n');
    document.head.appendChild(s);
  }

  function targetSlots() {
    /* Cart drawer (most important spot) */
    var drawerHosts = [
      '.cart-drawer__inner', '.cart-drawer .cart-drawer__body', '.cart-drawer-inner',
      '.cart-drawer', '[data-cart-drawer]',
      '.ajax-cart', '.cart-modal', '.cart-popup'
    ];
    var slots = [];
    drawerHosts.forEach(function(sel) {
      document.querySelectorAll(sel).forEach(function(el) {
        if (slots.indexOf(el) === -1) slots.push(el);
      });
    });
    /* Cart page */
    document.querySelectorAll('.cart-page, .template-cart .cart-form, [data-cart-page]').forEach(function(el) {
      if (slots.indexOf(el) === -1) slots.push(el);
    });
    return slots;
  }

  function renderInto(host, html) {
    /* Reuse existing bar if present, otherwise prepend */
    var existing = host.querySelector(':scope > .cdst-shipbar');
    if (existing) {
      existing.outerHTML = html;
    } else {
      host.insertAdjacentHTML('afterbegin', html);
    }
  }

  var lastSubtotal = -1;
  var debounceTimer = null;

  function updateBars(force) {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function() { fetchAndRender(force); }, POLL_DEBOUNCE_MS);
  }

  function fetchAndRender(force) {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var subtotal = cart.total_price || 0;
        if (!force && subtotal === lastSubtotal) return;
        lastSubtotal = subtotal;
        var remaining = Math.max(0, THRESHOLD_CENTS - subtotal);
        var html = makeBarHTML(remaining, subtotal);
        var slots = targetSlots();
        slots.forEach(function(s) { renderInto(s, html); });
      })
      .catch(function() {});
  }

  /* Intercept fetch to re-poll on cart mutations */
  var origFetch = window.fetch;
  window.fetch = function(input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    if (url && (/\/cart\/(add|change|update|clear)/).test(url)) {
      p.then(function() { setTimeout(updateBars, 80); });
    }
    return p;
  };

  /* Listen to common theme cart events */
  ['cart:added', 'cart:updated', 'cart:refreshed', 'cart:open', 'product:added-to-cart'].forEach(function(ev) {
    document.addEventListener(ev, function() { updateBars(true); }, true);
  });

  /* Listen for cart drawer opens (MutationObserver on body for class additions) */
  var bodyObs = new MutationObserver(function(muts) {
    muts.forEach(function(m) {
      if (m.attributeName === 'class') {
        var cls = document.body.className;
        if (/cart-drawer-active|cart-open|drawer-cart-open|drawer-open|menu-cart-open/.test(cls)) {
          updateBars(true);
        }
      }
    });
  });
  bodyObs.observe(document.body, { attributes: true, attributeFilter: ['class'] });

  injectStyles();
  /* Initial fetch + 1s delayed re-render to catch async-loaded cart drawer */
  updateBars(true);
  setTimeout(function() { updateBars(true); }, 1500);
})();
